import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { useModal } from 'hooks/modalContext';

/* 컴포넌트 */
import Header from 'layout/Header';
import SideNav from 'layout/SideNav';

/* 모달 컴포넌트 */
import ClientManagementModal from 'components/client/ManagementModal';
import ClientQRModal from 'components/client/QrInfoModal';
import ClientDispatchModal from 'components/client/DispatchModal';
import WorkforceDispatchModal from 'components/workforce/DispatchModal';
import AdministratorModal from 'components/workforce/AdministratorModal';
import WorkforceCheckInModal from 'components/workforce/CheckInModal';
import WorkforceGoToWorkModal from 'components/workforce/GoToWorkModal';
import WorkforceCheckOutModal from 'components/workforce/CheckOutModal';
import WorkforceGetOffWorkModal from 'components/workforce/GetOffWorkModal';
import NfcHistoryModal from 'components/workforce/NfcHistoryModal';
import ProductTypeModal from 'components/storage/product/ProductTypeModal';
import WarehousingModal from 'components/storage/WarehousingModal';
import ProductHistoryModal from 'components/storage/product/ProductHistoryModal';
import ClientTypeModal from 'components/client/ClientTypeModal';
import ManageCaptureModal from 'components/client/ManageCaptureModal';
import ReportCheckModal from 'components/client/ReportCheckModal';
import SelectExcelRead from '../components/client/SelectExcelRead';
import CheckListAdd from '../components/client/CheckListAdd';
import CustomerNfcHistoryModal from '../components/customer/CustomerNfcHistoryModal';
import TobAccountModal from '../components/tob/TobAccountModal';
import TobOrderDetailModal from '../components/tob/TobOrderDetailModal';
import DiscountModal from '../components/tob/DiscountModal';
import ImgDetailModal from '../components/customer/ImgDetailModal';

const Layout = () => {
  const { modalType, isModalOpen, closeModal, props } = useModal();

  const renderModalContent = () => {
    switch (modalType) {
      case 'ClientManagementModal':
        return <ClientManagementModal props={props}/>;
      case 'ClientQRModal':
        return <ClientQRModal props={props}/>;
      case 'ClientDispatchModal':
        return <ClientDispatchModal props={props}/>;
      case 'ClientTypeModal':
        return <ClientTypeModal props={props}/>;
      case 'CheckUserModal':
        return <ReportCheckModal props={props}/>;
      case 'ManageCaptureModal':
        return <ManageCaptureModal props={props}/>;
      case 'AdministratorModal':
        return <AdministratorModal props={props}/>;
      case 'WorkforceDispatchModal':
        return <WorkforceDispatchModal props={props}/>;
      case 'WorkforceCheckInModal':
        return <WorkforceCheckInModal props={props}/>;
      case 'WorkforceGoToWorkModal':
        return <WorkforceGoToWorkModal props={props}/>;
      case 'WorkforceCheckOutModal':
        return <WorkforceCheckOutModal props={props}/>;
      case 'WorkforceGetOffWorkModal':
        return <WorkforceGetOffWorkModal props={props}/>;
      case 'NfcHistoryModal':
        return <NfcHistoryModal props={props}/>;
      case 'ProductTypeModal':
        return <ProductTypeModal props={props}/>;
      case 'WarehousingModal':
        return <WarehousingModal props={props}/>;
      case 'ProductHistoryModal':
        return <ProductHistoryModal props={props}/>;
      case 'SelectExcelRead':
        return <SelectExcelRead props={props}/>;
      case 'CheckListAdd':
        return <CheckListAdd props={props} />;
      case 'CustomerNfcHistoryModal':
        return <CustomerNfcHistoryModal props={props}/>;
      case 'TobAccountModal':
        return <TobAccountModal props={props}/>;
      case 'TobOrderDetailModal':
        return <TobOrderDetailModal props={props}/>;
      case 'DiscountModal':
        return <DiscountModal props={props}/>;
      case 'ImgDetail':
        return <ImgDetailModal props={props}/>;
      default:
        return null;
    }
  };

  return (
    <>
      {/* 메인 컨텐츠 */}
      <ContentWrap>
        <Header/>
        <ContentBox>
          <SideNav/>
          <Outlet/>
        </ContentBox>
      </ContentWrap>

      {/* 모달 영역 */}
      {isModalOpen && (
        <Modal>
          <ModalWrapper>{renderModalContent()}</ModalWrapper>
          <Dimmed onClick={closeModal}/>
        </Modal>
      )}
    </>
  );
};

const ContentWrap = styled.div`
  & * {
    font-family: 'Apple SD Gothic Neo', serif;
  }
`;

const ContentBox = styled.div`
  padding: 25px 40px;
  position: relative;
  display: flex;
  gap: 0 60px;
`;

const Modal = styled.div`
  & * {
    font-family: 'Apple SD Gothic Neo', serif;
  }
  
  z-index:99;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const ModalWrapper = styled.div`
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .close-modal-btn {
    z-index: 99;
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;

const Dimmed = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
`;

export default Layout;
